import api from './';

export default {
  apiGetCustomers: params => api.post('/customer/index', params),
  apiAddCustomer: params => api.post('/customer/add', params),
  apiEditCustomer: params => api.post('/customer/edit', params),
  apiDeleteCustomer: params => api.post('/customer/del', params),
  apiGetCustomerPeople: params => api.post('/customer/peopleList', params),
  apiSetCustomerDefault: params => api.post('/customer/peopleDefault', params),
  apiAddCustomerPeople: params => api.post('/customer/peopleAdd', params),
  apiEditCustomerPeople: params => api.post('/customer/peopleEdit', params),
  apiDeleteCustomerPeople: params => api.post('/customer/peopleDel', params),
};



// WEBPACK FOOTER //
// ./src/api/customer.js